import React from "react";
import { Container, Grid } from "@mui/material";
import MealPlanHeader from "./MealPlanHeader";
import MealPlanDescription from "./MealPlanDescription";
import MealPlanRecipes from "./MealPlanRecipes";
import MealPlanShoppingList from "./MealPlanShoppingList";
import { StyledCard, CardContentWrapper } from "./StyledComponents";

/**
 * MealPlanDetailsContent component organizes and displays all meal plan information
 *
 * @param {Object} mealPlan - The meal plan object to display
 * @param {Array} recipes - List of scheduled recipes in the meal plan
 * @param {Array} ingredients - List of ingredients from the recipes
 * @param {Object} weeklySchedule - Weekly schedule of recipes by day
 * @param {Object} dailyNutritionTotals - Daily nutrition breakdowns
 * @param {Object} overallAverages - Average daily nutrition values
 * @param {Function} onEditClick - Function to handle edit button click
 * @param {Function} onRecipeClick - Function to handle recipe click
 * @param {string} organizationId - Organization ID for smart shopping list
 * @param {string} mealPlanId - Meal plan ID for smart shopping list
 */
const MealPlanDetailsContent = ({
  mealPlan,
  recipes,
  ingredients,
  weeklySchedule,
  dailyNutritionTotals,
  overallAverages,
  onEditClick,
  onRecipeClick,
  organizationId,
  mealPlanId,
}) => {
  if (!mealPlan) {
    return null;
  }

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      {/* Header Card with Meal Plan Name and Basic Info */}
      <MealPlanHeader 
        mealPlan={mealPlan} 
        overallAverages={overallAverages}
        onEditClick={onEditClick} 
      />

      {/* Main Content Area */}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <StyledCard>
            <CardContentWrapper>
              {/* Description Section */}
              <MealPlanDescription description={mealPlan.description} />

              {/* Recipes Section */}
              <MealPlanRecipes 
                recipes={recipes} 
                weeklySchedule={weeklySchedule}
                dailyNutritionTotals={dailyNutritionTotals}
                onRecipeClick={onRecipeClick}
              />

              {/* Shopping List Section */}
              <MealPlanShoppingList 
                organizationId={organizationId}
                mealPlanId={mealPlanId}
                ingredients={ingredients}
              />
            </CardContentWrapper>
          </StyledCard>
        </Grid>
      </Grid>
    </Container>
  );
};

export default MealPlanDetailsContent;
